<script setup lang="ts">
import { XMarkIcon } from '@heroicons/vue/24/outline'

defineProps<{
  dismissible?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
}>()
</script>

<template>
  <div class="relative flex h-full flex-col overflow-hidden rounded-lg text-white">
    <div
      class="pointer-events-none absolute inset-0 rotate-180 bg-cover bg-center bg-[url(/auth/login-modal-bg.webp)]"
      aria-hidden="true"
    />

    <img
      src="/auth/register-product.webp"
      alt=""
      aria-hidden="true"
      class="pointer-events-none absolute right-18.5 top-25 h-[700px] max-w-none select-none"
    >

    <div class="relative flex items-start justify-between p-8">
      <img
        src="/app/logo-light.svg"
        alt="Forgd"
        class="h-[18px] w-auto"
      >
      <button
        v-if="dismissible"
        type="button"
        class="-mr-1 -mt-1 flex h-8 w-8 items-center justify-center rounded-md text-white/80 transition-colors hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
        aria-label="Close"
        @click="emit('close')"
      >
        <XMarkIcon class="h-5 w-5" />
      </button>
    </div>
  </div>
</template>
